var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuidelineDonTs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0.1875C3.86875 0.1875 0.1875 3.86875 0.1875 8.5C0.1875 13.1313 3.86875 16.8125 8.5 16.8125C13.1313 16.8125 16.8125 13.1313 16.8125 8.5C16.8125 3.86875 13.1313 0.1875 8.5 0.1875ZM11.7063 12.6562L8.5 9.45L5.29375 12.6562L4.34375 11.7063L7.55 8.5L4.34375 5.29375L5.29375 4.34375L8.5 7.55L11.7063 4.34375L12.6562 5.29375L9.45 8.5L12.6562 11.7063L11.7063 12.6562Z",
    fill: "#ED4365"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelineDonTs);
export default __webpack_public_path__ + "static/media/guideline_DONTs.1facaf18.svg";
export { ForwardRef as ReactComponent };